import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DOC_TYPES } from 'src/app/core/constants/FormLists';
import { GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { RequestBnpl, RequestData } from 'src/app/models/request-bnpl';
import { environment } from 'src/environments/environment';
import { BnplFeatureFlagService } from './bnpl-feature-flags.service';

@Injectable({
  providedIn: 'root'
})
export class BnplBancolombiaService {

  urlGlobalApi = `${environment.urlglobal_api}/bnpl`;
  infoRequestValida: RequestData = {
    name: 'Payvalida',
    lastName: 'Validda',
    documentType: DOC_TYPES.NIT.TEXT,
    documentNumber: environment.payvalida_nit,
    email: environment.support_email,
    phoneCode: GENERAL_CONSTANTS.PHONE_PREFIX_COLOMBIA,
    phoneNumber: environment.payvalidaPhone.toString()
  }
  constructor(
    private http: HttpClient, 
    private bnplFeatureFlagService: BnplFeatureFlagService
  ) {}
  /**
  * @description: {buyerInformation} Function to call the buyer information service
  */
  buyerInformation = (resquestBody: RequestBnpl): Observable<any> => {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }
    return this.http.post<any>(`${this.urlGlobalApi}/buyerinformation`, resquestBody, headers).pipe(map((res: any) => res));
  }
  /**
  * @description: {returnRequestPayvalida} Function to call the buyer information service
  */
  returnRequestPayvalida = () => {
    return this.infoRequestValida;
  }
  /**
   * 
   * @description {loadLaunchDarkly} Function to get FF values to the BNPL group
   * @returns Promise with FF esponse value
   * @param featureName FF name
  */
  loadLaunchDarkly = (featureName: string) => {
    return new Promise((resolve, reject) => {
      this.bnplFeatureFlagService.initFlags().subscribe({
        next: () => {
          resolve(this.bnplFeatureFlagService.getFlagValue(featureName));
        }, error: (err) => {
          reject(err);
        }
      });
    })
  }
}
